export default __webpack_public_path__ + "static/media/home-grey.bc4a29d6.svg";